import styled from '@emotion/styled'

export const DocumentTimelineStatusWrapper = styled.div``
